// eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
function noop(..._args: any[]): any {}

export {noop};
